import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfigService } from 'src/app/core/app-config.service';
import { DataService } from 'src/app/core/data.service';
import { Subscription } from '../models/subscription';
@Injectable({
  providedIn: "root",
})
export class SubscriptionDataService extends DataService<Subscription> {
  constructor(http: HttpClient, acs: AppConfigService) {
    super(http, "Subscriptions", acs, false);
  } 
}
